import { Coordinates, Incident } from "@/types/incidents";
import * as mgrs from "mgrs";

export const parseCoordinates = (location: any) => {

  try {

   const locationdata={
        lat:Number.parseFloat(location.lat)||0,
        lng:Number.parseFloat(location.lng)||0,
        speed:Number.parseFloat(location.speed)||0,
        altitude: Number.parseFloat(location.altitude)||0,
        direction: Number.parseFloat(location.direction )||0,
        activity: location.activity||"still",
        odometer:location.odometer||0
   }
return locationdata;
  } catch {
    return {
      lat: 0,
      lng: 0,
    };
  }
};

export const getIncidentLocation = (incident: Incident) => {
  try {
    const userLocation = incident.userLocationDetail ?? incident?.ReportedByUser.lastLocationDetail;
    if(userLocation)
    return typeof(userLocation)==='string'? parseCoordinates(JSON.parse(userLocation)):userLocation ;
  else{
    return parseCoordinates(userLocation)
  }
  } catch {
    return {
      lat: 0,
      lng: 0,
    };
  }
};

export const getMGRSCoordinates = (coordinates: Coordinates | null): string => {
  if (!coordinates) return "No coordinates available";
  return mgrs.forward([coordinates.lng, coordinates.lat]);
};
